import React from 'react';
import { IMatrixMessage } from '../../../client/message/types';

interface RoomTombstoneMessageProps {
  message: IMatrixMessage;
  className?: string;
}

export const RoomTombstoneMessage = ({ message, className = '' }: RoomTombstoneMessageProps) => {
  const replacement = message.content.replacement_room;
  return (
    <div className={`room-tombstone-message ${className}`} style={{ color: '#bdbdbd', padding: '8px 0' }}>
      房间已废弃，迁移至 {replacement ? `「${replacement}」` : '新房间'}
    </div>
  );
}; 